import apiClient from './api';

const getPublishedBlogs = async () => {
  const res = await apiClient.get('/blogs');
  return res.data?.blogs ?? [];
};

const getBlogById = async (id) => {
  const res = await apiClient.get(`/blogs/${id}`);
  return res.data?.blog ?? null;
};

const getAdminBlogs = async () => {
  const res = await apiClient.get('/blogs/admin/all');
  return res.data?.blogs ?? [];
};

const createBlog = async (payload) => {
  const res = await apiClient.post('/blogs', payload);
  return res.data?.blog ?? res.data;
};

const updateBlog = async (id, payload) => {
  const res = await apiClient.put(`/blogs/${id}`, payload);
  return res.data?.blog ?? res.data;
};

const blogService = {
  getPublishedBlogs,
  getBlogById,
  getAdminBlogs,
  createBlog,
  updateBlog,
};

export default blogService;
